/**
 * What: Shopify order-history allowance boundary for ingestion planning.
 * Transport / data-flow: Pure policy constants; no D1, network, or credential access.
 * Shopify grants order access for the last 60 days by default; older orders require
 * the read_all_orders scope via Partner Dashboard approval, which this project has
 * decided against pursuing. The ingestion target therefore equals the allowance:
 * days beyond it return empty (never an error), so planners must treat them as
 * unverifiable, not quiet, and the target must never exceed what is collectable.
 */
export const SHOPIFY_DEFAULT_ORDER_HISTORY_DAYS = 60;
/** Days of order history the pipeline plans, collects, and promises. Always the allowance. */
export const SHOPIFY_INGESTION_TARGET_DAYS = SHOPIFY_DEFAULT_ORDER_HISTORY_DAYS;
/**
 * What: Bounded Shopify materialization slice size for one signed request.
 * Transport / data-flow: Pure policy constant; Web must never dispatch more
 * partition keys than Shopify will accept, and Shopify validates against this
 * same constant. Keeps the 90-day upper bound above the 60-day collection
 * target so a complete window always fits in one slice.
 */
export const SHOPIFY_MATERIALIZATION_MAX_PARTITIONS = 90;
//# sourceMappingURL=shopify-order-history-horizon.js.map